import { QueryModel } from './../../../../shared/Models/queryModel';
import { SourceMasterService } from './../../../source.master/services/source.master.service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { PagingService } from './../../../../shared/Services/PagingService';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { FieldPropsService } from '../../services/forms-props.service';
import { FormsFieldService } from '../../../formsFields/services/forms-fields.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'formsfeild-get',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetFieldPropsComponent extends BaseComponent implements OnInit {
  typeId: number;
  fieldId: number;

  item: any;
  formsfieldslist: any[];
  sources: any[] = [];
  callCount = 0;
  finishSource: boolean;
  public tools: object = {
    items: [
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      '|',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      '|',
      'LowerCase',
      'UpperCase',
      '|',
      'Undo',
      'Redo',
      '|',
      'Formats',
      'Alignments',
      '|',
      'OrderedList',
      'UnorderedList',
      '|',
      'Indent',
      'Outdent',
      '|',
      'CreateLink',
      'CreateTable',
      'Image',
      '|',
      'ClearFormat',
      'Print',
      'SourceCode',
      '|',
      'FullScreen',
    ],
  };
  questions: boolean;
  selectedDataSources: any;
  constructor(
    public route: Router,
    public service: FieldPropsService,
    public paging: PagingService,
    private activated: ActivatedRoute,
    private diag: NbDialogRef<GetFieldPropsComponent>,
    private fieldservice: FormsFieldService,
    private source: SourceMasterService,
    private toast: NbToastrService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    const id = this.activated.snapshot.params.id;
    this.formsfieldslist = this.item.fieldsProperties;

    this.formsfieldslist.forEach((item) => {
      if (item.fieldPropertyType != null && item.fieldPropertyType === 2 && this.callCount === 0) {
        this.callCount = 1;
        this.getSources();

        this.finishSource = true;
      }
    });
    // this.pagingModel.query.searchTerm = 'FormMasterId:' + id;
    // this.loadEntities();
    // this.service.getData(`getProps?typeId=${this.typeId}&formId=${this.fieldId}`).subscribe();
  }

  formsfields(id) {
    this.route.navigate(['admin/dynamicForms/formsfields/' + id]);
  }

  save() {
    this.item.fieldsProperties = this.formsfieldslist;
    this.fieldservice.put(this.item.id, this.item).subscribe((res) => {
      this.toast.success(`add field properties successfully`, 'success', { duration: 4000 });

      this.diag.close('true');
    });
  }

  getSources() {
    let query = new QueryModel();
    query.pageSize = 100;
    this.source.get(query).subscribe(
      (res) => {
        this.sources = res.result;
      },
      (error) => {
        return [];
      }
    );
  }

  checkType(type, sourceId) {
    console.log(type);

    if (type === 11) {
      this.questions = true;
      this.sources.forEach((element) => {
        console.log(element);

        if (element.id == sourceId) {
          this.selectedDataSources = element.dataSourceValues;
        }
      });
    }
  }
}
